import { useState } from 'react';
import { useIntl } from 'react-intl';

import { ChipButton } from '@calm-web/design-system';

import { useLocale } from '@/hooks/locale/useLocale';

import { featuresMessages } from '../messages';
import { Headline } from '../styles';
import featuresData, { localeImages } from './data';
import Feature from './feature';
import { ButtonsWrapper, Section } from './styles';
import type { FeatureName, Feature as FeatureType, StaticImageData } from './types';

const ContentTeaser = () => {
	const [currentSection, setCurrentSection] = useState<FeatureName>('dailySeries');
	const feature: FeatureType = featuresData[currentSection];
	const buttons = Object.entries(featuresData);

	const { calmLanguage } = useLocale();

	const localeImage =
		currentSection in localeImages[calmLanguage] ? localeImages[calmLanguage][currentSection] : undefined;

	const { formatMessage } = useIntl();
	return (
		<Section>
			<Headline>{formatMessage(featuresMessages.featuresHeadline)}</Headline>
			<ButtonsWrapper>
				{buttons.map(([k, v]) => (
					<ChipButton
						focusRingVariant="dark"
						isActive={currentSection === k}
						key={k}
						onPress={() => {
							setCurrentSection(k as FeatureName);
						}}
					>
						{formatMessage(v.buttonText)}
					</ChipButton>
				))}
			</ButtonsWrapper>
			<Feature {...feature} image={localeImage as StaticImageData} />
		</Section>
	);
};

export default ContentTeaser;
